var map = {
	"./en.json": 90676,
	"./es.json": 2511,
	"./fr.json": 80344,
	"./it.json": 97924,
	"./nl.json": 24473,
	"./pt.json": 30758,
	"./ru.json": 47321,
	"./zh.json": 46381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38209;